<qwiko-onboarding-nav></qwiko-onboarding-nav>
<div class="max-h-screen overflow-y-auto pb-24">
  <router-outlet></router-outlet>
</div>
